<template>
  <div class="container">
    <div class="box-title" :style="{marginTop: '-15px'}">
      <h4>
        <i class="fal fa-gifts"></i>
        ລາຍການທັງໝົດ
      </h4>
    </div>

    <div class="box" style="margin-bottom: 12px;margin-top: -12px;">
      <div class="columns">
        <div class="column is-2">
          <div class="field">
            <div class="control">
              <label class="label">ຄົ້ນຫາເລກບິນເທົ່ານັ້ນ:</label>
              <input
                  class="input"
                  placeholder="ເລກບິນເທົ່ານັ້ນ"
                  type="text" name="name"
                  v-model="searchItem"
                  @keyup.enter="resetAndSearch()"
              >
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="center table-limit-height">
      <vs-table v-if="getOrdersList.length !== 0" :loading="loading">
        <template #thead>
          <vs-tr>
            <vs-th></vs-th>
            <vs-th>ສະຖານະ</vs-th>
            <vs-th>ລາຍລະອຽດບິນ</vs-th>
            <vs-th>ຮູບລາຍເຊັນ</vs-th>
            <vs-th>ໝາຍເຫດ</vs-th>
            <vs-th>ເລກທີບິນ</vs-th>
            <vs-th>ວັນທີຝາກເຄື່ອງ</vs-th>
            <vs-th>ວັນທີແກ້ໄຂບິນ</vs-th>
            <vs-th>ວັນທີເຄື່ອງຮອດ</vs-th>
            <vs-th>ວັນທີຈັດສົ່ງສຳເລັດ</vs-th>
            <vs-th>ຈຳນວນ</vs-th>
            <vs-th>ນ້ຳໜັກ</vs-th>
            <vs-th>ສ່ວນຫຼຸດ</vs-th>
            <vs-th v-if="$route.query.tab === 'origin_freight_fees'">ຄ່າຂົນສົ່ງຕົ້ນທາງ</vs-th>
            <vs-th v-else-if="$route.query.tab === 'destination_freight_fees'">ຄ່າຂົນສົ່ງປາຍທາງ</vs-th>
            <vs-th v-else-if="$route.query.tab === 'origin_freight_fees_cod'">ຄ່າຂົນສົ່ງຕົ້ນທາງ</vs-th>
            <vs-th v-else>ຄ່າຂົນສົ່ງ</vs-th>
            <vs-th>ປະກັນໄພ</vs-th>
            <vs-th>ລວມຄ່າຂົນສົ່ງ</vs-th>
            <vs-th>ຄ່າຕີກັບ</vs-th>
            <vs-th>ຄ່າຝາກສາງ</vs-th>
            <vs-th>ຄ່າສິນຄ້າ</vs-th>
            <vs-th>ຊື່ຜູ້ສົ່ງ</vs-th>
            <vs-th>ຊື່ຜູ້ຮັບ</vs-th>
            <vs-th>ສາຂາຕົ້ນທາງ</vs-th>
            <vs-th>ສາຂາປາຍທາງ</vs-th>
            <vs-th>ປະເພດການຊຳລະ</vs-th>
            <vs-th>ປະເພດຂົນສົ່ງ</vs-th>
            <vs-th>ຜູ້ຮັບຜິດຊອບ</vs-th>
            <vs-th>ຜູ້ຈັດສົ່ງ</vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
              :key="index"
              v-for="(item, index) in getOrdersList">
            <vs-td style="text-align: right; width: 100px">
              <div class="group-icon">
                <vs-button
                    v-if="item.shipment_status_id === 3 && $can('SuperAdmin')"
                    circle icon flat
                    @click="OpenModalCancel(item.shipment_number)">
                  <i class="fad fa-window-close"></i>
                </vs-button>
                <vs-button circle icon flat
                           @click="$router.push({name: 'list.shipment.detail', params:{id: item.id}})">
                  <i class="fad fa-eye"></i>
                </vs-button>
              </div>
            </vs-td>
            <vs-td
                v-if="item.tracking_state_id === 5 && (item.shipment_status_id === 2 || item.shipment_status_id === 6 || item.shipment_status_id === 8)">
              ເຄື່ອງຮອດສາຂາປາຍທາງ
            </vs-td>
            <vs-td v-else>{{ la_status[item.shipment_status_name] }}</vs-td>
            <vs-td>{{ item.tracking }}</vs-td>
            <vs-td>
              <div v-if="item.signature_file" class="img-size">
                <expandable-image
                    class="image"
                    :src=item.signature_file
                ></expandable-image>
              </div>
            </vs-td>
            <vs-td>{{ item.remark }}</vs-td>
            <vs-td :style="{color: 'crimson'}">( {{ item.shipment_number }} )</vs-td>
            <vs-td v-if="item.shipment_status_id === 1">{{ FormatDate(item.created_at) }}</vs-td>
            <vs-td v-else>{{ FormatDate(item.start_date_actual) }}</vs-td>
            <vs-td v-if="item.shipment_status_id !== 1
            && item.shipment_status_id !== 2
            && item.shipment_status_id !== 3
            && item.shipment_status_id !== 11">{{ FormatDate(item.updated_at) }}
            </vs-td>
            <vs-td v-else></vs-td>

            <vs-td v-if="item.tracking_state_id === 5 || item.tracking_state_id === 6">
              {{ FormatDate(item.end_date_actual) }}
            </vs-td>
            <vs-td v-else></vs-td>

            <vs-td v-if="item.shipment_status_id === 11">
              {{ FormatDate(item.end_date_actual) }}
            </vs-td>
            <vs-td v-else-if="item.shipment_status_id === 3">
              {{ FormatDate(item.updated_at) }}
            </vs-td>
            <vs-td v-else></vs-td>

            <vs-td>{{ item.pieces || 0 }}</vs-td>
            <vs-td>{{ item.weight || 0 }}</vs-td>
            <vs-td>
              <span v-if="item.total_discount_amount !== 0">{{ item.total_discount_amount }}ກີບ</span>
              <span v-if="item.total_discount_percent !== 0">{{ item.total_discount_percent }}%</span>
              <span v-if="item.total_discount_amount === 0 && item.total_discount_percent === 0">........</span>
            </vs-td>
            <vs-td>( {{ FormatPrice(item.sub_total_freight) }} )</vs-td>
            <vs-td>( {{ FormatPrice(item.total_insurance_price) }} )</vs-td>
            <vs-td :style="{color: 'crimson'}">( {{ FormatPrice(item.total_freight) }} )</vs-td>
            <vs-td :style="{color: 'crimson'}">( {{ FormatPrice(item.reject_freight) }} )</vs-td>
            <vs-td :style="{color: 'crimson'}">( {{ FormatPrice(item.total_rental_price) }} )</vs-td>
            <vs-td :style="{color: 'crimson'}">( {{ FormatPrice(item.total_price) }} )</vs-td>
            <vs-td>{{ item.sender_customer_name }}</vs-td>
            <vs-td>{{ item.receiver_customer_name }}</vs-td>
            <vs-td>{{ item.start_branch_name }}</vs-td>
            <vs-td>{{ item.end_branch_name }}</vs-td>
            <vs-td>
              <span v-if="item.shipment_pay_type === 'origin_freight_fees'">ເກັບເງິນຕົ້ນທາງ</span>
              <span v-if="item.shipment_pay_type === 'destination_freight_fees'">ເກັບເງິນປາຍທາງ</span>
              <span v-if="item.shipment_pay_type === 'origin_freight_fees_cod'">ເກັບເງິນຕົ້ນທາງ ( COD )</span>
              <span v-if="item.shipment_pay_type === 'destination_freight_fees_cod'">ເກັບເງິນປາຍທາງ ( COD + CDC )</span>
            </vs-td>
            <vs-td :style="{color: 'crimson'}">
              ( {{ item.shipment_type }} )
            </vs-td>
            <vs-td>{{ item.created_by_name }}</vs-td>

            <vs-td v-if="item.shipment_status_id === 3">{{ item.sign_name }}</vs-td>
            <vs-td v-else></vs-td>
          </vs-tr>
        </template>
        <template #footer>
          <Pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="offset"
                      @paginate="FetchData"/>
          <Loading v-if="loading"/>
        </template>
      </vs-table>
      <vs-table v-else></vs-table>
    </div>
    <ModalCancel>
      <template v-slot="{ close }">
        <cancelSuccessOrder @close="close"
                            :shipment_number="shipment_number"
                            @success="FetchData()"/>
      </template>
    </ModalCancel>
  </div>
</template>

<script>

import Loading from '@/views/Loading';
import Pagination from '@/Plugins/Paginations/Pagination';
import MixinBranchListOrders from '@/Mixins/Shipments/Solve-Shipment';
import cancelSuccessOrder from "@views/Accounting/Shipments/Dialog/CancelSuccessOrder";

export default {
  components: {
    Loading,
    Pagination,
    cancelSuccessOrder
  },

  props: ['onclickEvent'],

  mixins: [MixinBranchListOrders],

  data() {
    return {
      // Pagination
      offset: 10,
      limit_page: 15,
      pagination: {
        current_page: 1,
        last_page: 1,
        total: 0,
        per_page: 15,
        from: 0,
        to: 0
      },
      listAllOrders: []
    };
  },

  methods: {
    // Fetch data with pagination support
    fetchInvoiceItemsResponse(page = null) {
      const currentPage = page || this.pagination.current_page;

      const params = {
        shipment_pay_type: this.$route.query.tab,
        query: this.searchItem,
        page: currentPage,
        per_page: this.limit_page,
      };

      return this.$axios.get('/list/solve/shipments', { params })
    },

    // Handle pagination response - supports both paginated and single record
    FetchData(page = null) {
      this.loading = true;

      // Update current page if provided
      if (page !== null) {
        this.pagination.current_page = page;
      }

      this.fetchInvoiceItemsResponse(page).then((res) => {
        const responseData = res.data;

        // Check if response has Laravel pagination structure
        if (responseData && 'data' in responseData && Array.isArray(responseData.data) && 'last_page' in responseData) {
          // Paginated response (e.g., phone number search)
          this.listAllOrders = responseData.data;
          this.pagination = {
            current_page: parseInt(responseData.current_page) || 1,
            last_page: parseInt(responseData.last_page) || 1,
            total: parseInt(responseData.total) || 0,
            per_page: parseInt(responseData.per_page) || 15,
            from: parseInt(responseData.from) || 0,
            to: parseInt(responseData.to) || 0
          };
        } else if (responseData && typeof responseData === 'object' && responseData.id) {
          // Single shipment object (e.g., shipment number search)
          this.listAllOrders = [responseData];
          this.pagination = {
            current_page: 1,
            last_page: 1,
            total: 1,
            per_page: 1,
            from: 1,
            to: 1
          };
        } else if (Array.isArray(responseData)) {
          // Array of shipments (non-paginated)
          this.listAllOrders = responseData;
          this.pagination = {
            current_page: 1,
            last_page: 1,
            total: responseData.length,
            per_page: responseData.length,
            from: responseData.length > 0 ? 1 : 0,
            to: responseData.length
          };
        } else {
          // Unexpected format or empty
          this.listAllOrders = [];
          this.pagination = {
            current_page: 1,
            last_page: 1,
            total: 0,
            per_page: 15,
            from: 0,
            to: 0
          };
        }

        this.loading = false;
      }).catch((error) => {
        console.error('API Error:', error);
        this.loading = false;
        this.listAllOrders = [];
      });
    },

    OpenModalCancel(shipmentNumber) {
      this.shipment_number = JSON.parse(JSON.stringify(shipmentNumber));
      this.$store.commit("modalCancel_State", true);
    },

    resetAndSearch() {
      // Reset to page 1 when searching
      this.pagination.current_page = 1;
      this.FetchData();
    }
  },

  computed: {
    getOrdersList() {
      return Array.isArray(this.listAllOrders) ? this.listAllOrders : [];
    }
  },

  watch: {
    'onclickEvent': function (value) {
      if (value !== '') {
        this.listAllOrders = [];
        this.searchItem = '';
        this.pagination.current_page = 1;
        this.FetchData();
      }
    }
  },

  created() {
    this.FetchData();
  }
}
</script>

<style lang="scss">
.btn-clear {
  background: $crimson;

  &:hover {
    color: $white;
  }
}

.vs-select__input {
  width: 55% !important;
  margin-left: -163px !important;
  border-radius: 5px !important;
  background: $white !important;
  border: 1px solid rgba(173, 172, 172, 0.562) !important;
}

.table-limit-height {
  .vs-table {
    width: 100%;
    font-size: 0.9rem;
    margin: 0;
    max-height: 500px;
  }
}

</style>
